import $ from "jquery";

$(() => {
  // const nav = $(".header");
  // const scrollHandler = () => {
  //   nav.toggleClass("scrolled", $(document).scrollTop() > nav.height());
  // };
  // $(document).on("scroll", function () {
  //   scrollHandler();
  // });
  // scrollHandler();

  // $(".menu-item-has-children > a").on("click", function (e) {
  //   e.preventDefault();
  //   const $target = $(this).parent(".menu-item-has-children");
  //   $target.toggleClass("menu-item-has-children--active");
  // });

  const hero = $("#hero-section");
  const about = $("#about-section");
  const navLinks = $("#nav-wrapper div ul li");
  const hamburgerSpans = $("#hamburger span");

  const scrollHandler = () => {
    const heroBottom = hero.position().top + hero.outerHeight(true);
    const aboutTop = about.position().top;
    if (navLinks.length) {
      navLinks.each((i, navLinkEl) => {
        const navLink = $(navLinkEl);
        const navPosition = navLink.offset().top;
        if (
          navPosition > heroBottom &&
          navPosition <= aboutTop &&
          $(window).width() >= 751
        ) {
          navLink.css("color", "black");
        } else {
          navLink.css("color", "white");
        }
      });
    }
    if (hamburgerSpans.length) {
      hamburgerSpans.each((i, spanEl) => {
        const span = $(spanEl);
        const spanPosition = span.offset().top;
        if (
          spanPosition > heroBottom &&
          spanPosition <= aboutTop &&
          !$("body").hasClass("menu--active")
        ) {
          span.css("background-color", "black");
        } else {
          span.css("background-color", "white");
        }
      });
    }
  };

  $(document).on("scroll", function () {
    scrollHandler();
  });
  scrollHandler();

  $("#hamburger").on("click", function (e) {
    e.preventDefault();
    const $target = $("body");
    $target.toggleClass("menu--active");
    scrollHandler();
  });

  $(".nav-primary div .nav li a").on("click", function (e) {
    const $target = $("body");
    $target.removeClass("menu--active");
  });

  $(".not-nav").on("click", function (e) {
    const $target = $("body");
    $target.removeClass("menu--active");
  });
});
